function toDateValue(value) {
  const date =
    value?.toDate?.() ?? (value instanceof Date ? value : value ? new Date(value) : null);
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  return date;
}

function applyTime(date, timeValue) {
  if (typeof timeValue !== 'string' || timeValue.trim() === '') return null;
  const [hours, minutes] = timeValue.trim().split(':').map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  const next = new Date(date);
  next.setHours(hours, minutes, 0, 0);
  return next;
}

export function getOutingEndTime(outing = {}) {
  const date = toDateValue(outing?.date);
  if (!date) return null;
  const timedDate = applyTime(date, outing?.toTime || outing?.fromTime);
  if (timedDate) return timedDate;
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
}

export function isOutingPast(outing = {}, now = new Date()) {
  const endTime = getOutingEndTime(outing);
  if (!endTime) return false;
  return endTime.getTime() < now.getTime();
}
